import { AccessibilityContext } from '@app/app/_context/AccessibilityContext/AccessibilityContext';
import { useContext } from 'react';

export function useHighContrastMode(): boolean {
    const { isHighContrastMode } = useContext(AccessibilityContext);
    return isHighContrastMode;
}
